import { useState } from "react";

const PartnerDepartmentReadOnlyRow = ({ index, t, partnerDeptItem, handleDeleteClick, oddIdx, setError }) => {
	const [isSubmit, setIsSubmit] = useState(false);

	function submitComplete() {
		setIsSubmit(false);
	}

	function submitDelete(event, partnerDeptItem) {
		setError("");
		setIsSubmit(true);
		handleDeleteClick(event, partnerDeptItem, submitComplete);
	}

	return (
		<tr key={index}>
			<td className={oddIdx ? "list-td col text-wrap odd" : "list-td col text-wrap even"}>{partnerDeptItem.departmentName}</td>
			<td className={oddIdx ? "list-td col odd" : "list-td col even"}>{partnerDeptItem.status}</td>
			<td className={oddIdx ? "list-td col col-md-auto odd" : "list-td col col-md-auto even"}>
				<div id="submit-spinner"
					className={isSubmit ? "spinner-border spinner-border-sm text-dark spinner-size" : "spinner-hide"}
				>
				</div>
				<button className={isSubmit ? "btn btn-primary btn-block me-4 pe-none" : "btn btn-primary btn-block"} onClick={(event) => submitDelete(event, partnerDeptItem)}>
					{partnerDeptItem.statusCode === 1 ? t("page.delete") : t("page.undelete")}</button>
			</td>
		</tr>
	)
}
export default PartnerDepartmentReadOnlyRow;